import { render, staticRenderFns } from "./PublicationCategoryModalForm.vue?vue&type=template&id=6ec4f76f&scoped=true"
import script from "./PublicationCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./PublicationCategoryModalForm.vue?vue&type=script&lang=js"
import style0 from "./PublicationCategoryModalForm.vue?vue&type=style&index=0&id=6ec4f76f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4f76f",
  null
  
)

export default component.exports